import { _ as _objectSpread2 } from './index-03130070.esm.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-7e1dfdab.esm.js';
import { forwardRef } from 'react';
import cuid from 'cuid';
import isChromatic from 'chromatic/isChromatic';
import { I as IconWrapper } from './index.style-741fda20.esm.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { S as Spacer } from './index-9102c435.esm.js';
import { pxToRem, filterGlobalProps } from '@lendi-ui/commons/utils';
import { I as InputBaseComponent, u as useClearAction, F as FieldLabel, C as ClearActionButton, H as HelpText, E as ErrorText } from './TextField-18fb9ee7.esm.js';
import styled from 'styled-components';
import './RichText-50b4a7f5.esm.js';
import 'react-helmet';
import '@reach/visually-hidden';
import 'react-element-to-jsx-string';
import { u as useTheme } from './index-83c6f867.esm.js';

/**
 * This is a 100% duplicate of `@lendi-ui/icon/Call`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgCall(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      })]
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/icon/PhoneAndroid`.
 *
 * It is used in LUI Next PhoneField
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SvgPhoneAndroid(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("path", {
        d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })]
    })
  }));
}

var Wrapper = styled.div.withConfig({
  displayName: "PhoneFieldstyle__Wrapper",
  componentId: "lui__sc-c2e1lq-0"
})(["position:relative;width:100%;"]);
var Input = styled(InputBaseComponent).withConfig({
  displayName: "PhoneFieldstyle__Input",
  componentId: "lui__sc-c2e1lq-1"
})(["padding-left:", ";padding-right:", ";"], pxToRem(46), _ref => {
  var {
    hasRightItem
  } = _ref;
  return hasRightItem ? pxToRem(46) : pxToRem(16);
});
var PhoneIconWrapper = styled.span.withConfig({
  displayName: "PhoneFieldstyle__PhoneIconWrapper",
  componentId: "lui__sc-c2e1lq-2"
})(["position:absolute;top:", ";left:", ";"], pxToRem(12), pxToRem(12));
var MobileIconWrapper = styled.span.withConfig({
  displayName: "PhoneFieldstyle__MobileIconWrapper",
  componentId: "lui__sc-c2e1lq-3"
})(["position:absolute;top:", ";left:", ";"], pxToRem(12), pxToRem(12));

var getPattern = variant => {
  switch (variant) {
    case 'mobile':
      return "^04{1}[0-9]{2}[0-9]{3}[0-9]{3}$";
    default:
      return "^0{1}[2378]{1}[0-9]{4}[0-9]{4}$";
  }
};

var _excluded = ["inputId", "name", "variant", "helpText", "errorText", "validationState", "placeholder", "ariaLabel", "ariaLabelledBy", "label", "labelSuffix", "inlineAction", "isRequired", "isDisabled", "value", "defaultValue", "onChange", "width", "maxCharCount", "minCharCount", "minWidth", "maxWidth"];
var filterAlphabet = value => value.replace(/\D*/g, '');
var handleFormatting = value => {
  // because we handle uncontrolled, this function could receive undefined.
  if (value) {
    return filterAlphabet(value);
  }
  return value;
};
var PhoneFieldComponent = (_ref, ref) => {
  var {
      inputId,
      name,
      variant,
      helpText,
      errorText,
      validationState,
      placeholder,
      ariaLabel,
      ariaLabelledBy,
      label,
      labelSuffix,
      inlineAction,
      isRequired,
      isDisabled,
      value,
      defaultValue,
      onChange,
      width = '100%',
      maxCharCount,
      minCharCount,
      minWidth,
      maxWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var globalProps = filterGlobalProps(props);
  var inputElId = isChromatic() ? '1' : inputId !== null && inputId !== void 0 ? inputId : cuid();
  var helpTextId = isChromatic() ? '2' : cuid();
  var errorTextId = isChromatic() ? '3' : cuid();
  var hasError = errorText && validationState === 'invalid';
  var theme = useTheme();
  var handleValueChange = e => {
    if (e.target.value !== '') {
      var _handleFormatting;
      e.target.value = (_handleFormatting = handleFormatting(e.target.value)) !== null && _handleFormatting !== void 0 ? _handleFormatting : '';
    }
    if (onChange) {
      onChange(e);
    }
  };
  var {
    isCleared,
    handleChange,
    clearValue
  } = useClearAction(handleValueChange, ref, value);
  var ariaDescribedBy = [];
  if (helpText) {
    ariaDescribedBy.push(helpTextId);
  }
  if (hasError) {
    ariaDescribedBy.push(errorTextId);
  }
  return /*#__PURE__*/jsxs(Spacer, _objectSpread2(_objectSpread2({
    ygap: "xxs",
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, globalProps), {}, {
    children: [label && /*#__PURE__*/jsx(FieldLabel, {
      forId: inputElId,
      label: label,
      labelSuffix: labelSuffix
    }), /*#__PURE__*/jsxs(Spacer, {
      ygap: "xxs",
      children: [/*#__PURE__*/jsxs(Wrapper, {
        children: [variant === 'mobile' ? /*#__PURE__*/jsx(MobileIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgPhoneAndroid, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }) : /*#__PURE__*/jsx(PhoneIconWrapper, {
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(SvgCall, {
            color: isDisabled ? theme.color.interaction.disabled : theme.color.text.subtle,
            width: "24px",
            height: "24px"
          })
        }), /*#__PURE__*/jsx(Input, {
          id: inputElId,
          name: name,
          type: "tel",
          autoComplete: "tel",
          inputMode: "tel",
          pattern: getPattern(variant),
          placeholder: placeholder,
          validationState: validationState,
          "aria-invalid": validationState === 'invalid',
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined,
          required: isRequired,
          disabled: isDisabled,
          maxLength: maxCharCount,
          minLength: minCharCount,
          value: value && isCleared ? '' : handleFormatting(value),
          defaultValue: handleFormatting(defaultValue),
          onChange: handleChange,
          ref: ref,
          hasRightItem: !!inlineAction,
          variant: variant
        }), inlineAction === 'clear' && /*#__PURE__*/jsx(ClearActionButton, {
          isCleared: isCleared,
          clearValue: clearValue
        })]
      }), helpText && /*#__PURE__*/jsx(HelpText, {
        id: helpTextId,
        text: helpText
      }), hasError && errorText && /*#__PURE__*/jsx(ErrorText, {
        id: errorTextId,
        text: errorText
      })]
    })]
  }));
};
var PhoneField = /*#__PURE__*/forwardRef(PhoneFieldComponent);

export { PhoneField as P };
